import type { RouteRecordRaw } from 'vue-router'

export const mediaCategoriesRoutes: RouteRecordRaw[] = [
  {
    path: '/masters/media-categories',
    name: 'MEDIA_CATEGORIES',
    component: () => import('./MediaCategoriesPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin' },
  },
]
